import type {StyleRules} from '@material-ui/core/styles/withStyles'

export const styles = (theme): StyleRules => ({
  container: {
    minHeight: '100vh',
    overflow: 'hidden',
    display: 'flex',
    gap: '25px',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    width: '100%',
    padding: '30px 50px',
    '&:hover': {
      cursor: 'auto',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '20px',
    },
  },
  rowLabel: {
    margin: 0,
    fontSize: '22px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px',
    },
  },
  rowValue: {
    fontWeight: 'bold',
    fontSize: '22px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px',
    },
  },
  walletAddress: {
    fontWeight: 'bold',
    fontSize: '22px',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px',
    },
  },
  gridContainer: {alignItems: 'center'},
  divider: {
    width: '80%',
    margin: '10px auto',
    backgroundColor: theme.palette.red.color,
  },
  copyIcon: {
    color: theme.palette.red.color,
  },
  pointer: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  confirmButton: {
    backgroundColor: theme.palette.red.color,
    color: theme.palette.extralightgrey.color,
    '&:hover': {
      backgroundColor: theme.palette.red.color,
    },
  },
  confirmButtonRow: {
    justifyContent: 'space-around',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(1),
    },
  },
})
